import useDeepLinkListener from '@hooks/native/useDeepLinkListener';
import { useFlow } from '@router/stackflow';

function useDeepLink() {
    const { push } = useFlow();
    useDeepLinkListener(({
        deepLinkType,
        shopId, noticeId, eventId,
    }) => {
        console.log(`deeplink ${deepLinkType}, ${JSON.stringify({
            shopId, noticeId, eventId,
        })}`);
        switch (deepLinkType) {
        case 'EVENT':
            if (eventId) {
                push('EventActivity', { eventId });
            }
            break;
        case 'NOTICE':
            if (noticeId) {
                push('NoticeActivity', { noticeId });
            }
            break;
        case 'COUPON_BOX':
            push('CouponActivity', { type: 'MY' });
            break;
        case 'STAMP':
            push('StampsActivity', { });
            break;
        case 'ITEMS':
            if (shopId) {
                push('ItemsActivity', { shopId, type: 'ALL' });
            }
            break;
        case 'GIFT_BOX':
            push('GiftsActivity', { type: 'MAIN' });
            break;
        case 'PREPAID_CARD':
            push('MyPrepaidCardActivity', {});
            break;
        default:
            console.log('딥링크');
        }
    });
}

export default useDeepLink;
